import { Components } from '@mui/material';

const MuiAutocomplete: Components<any>['MuiAutocomplete'] = {
  styleOverrides: {
    listbox: ({ theme }) => ({
      '& .Mui-focused': {
        backgroundColor: `${theme.palette.background.default} !important`,
      },
      '&::-webkit-scrollbar-track': {
        marginBlock: theme.spacing(3),
      },
      '&::-webkit-scrollbar-thumb': {
        width: 0,
      },
      '& > li': {
        paddingInline: theme.spacing(3),
        paddingBlock: theme.spacing(2),
        borderRadius: theme.spacing(),
      },
      paddingInline: theme.spacing(1.5),
      paddingBlock: theme.spacing(3),
    }),
  },
};

export default MuiAutocomplete;
